import { render } from "./DTMilestones.vue?vue&type=template&id=6d90c58a&scoped=true"
import script from "./DTMilestones.vue?vue&type=script&lang=js"
export * from "./DTMilestones.vue?vue&type=script&lang=js"

import "./DTMilestones.vue?vue&type=style&index=0&id=6d90c58a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d90c58a"]])

export default __exports__